import { SESSION_DATA_SESSION_STORAGE_KEY } from './getSessionDataFromSessionStorage';
import { SessionData } from 'owa-service/lib/types/SessionData';
import { setItemInSessionStorage } from 'mini-session-storage';

export function storeSessionDetailsInSessionStorage(sessionData: SessionData) {
    setItemInSessionStorage(SESSION_DATA_SESSION_STORAGE_KEY, {
        owaUserConfig: sessionData.owaUserConfig,
        currentEpochInMs: sessionData.currentEpochInMs,
        extraSettings: sessionData.extraSettings,
        features: sessionData.features,
        language: sessionData.language,
        skipBuilds: sessionData.skipBuilds,
    });
}
